class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement =
            document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');


        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return;
            }
            this.onCartUpdate();
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    onChange(event) {
        if (event.target.id === 'gift-wrapping-checkbox' || event.target.id === 'gift-note-input') {
            return;
        }
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    onCartUpdate() {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const sourceQty = html.querySelector('cart-items');
                this.innerHTML = sourceQty.innerHTML;
            })
            .catch((e) => {
                console.error(e);
            });
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            }
        ];
    }

    updateQuantity(line, quantity, name) {
        const loader = document.querySelector('.js-cart-loader[data-loader]');
        window.Global.showLoader(loader);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement =
                    document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll('.js-cart-item');

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute('value');
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );

                }));

                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                let message = '';
                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === 'undefined') {
                        message = window.cartStrings.error;
                    } else {
                        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                    }
                }

                this.updateLiveRegions(line, message);

                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                }
                publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: parsedState});
            })
            .catch(() => {
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                errors.textContent = window.cartStrings.error;
            }).finally(() => {
            window.Global.hideLoader(loader);
        });
    }

    updateLiveRegions(line, message) {
        const lineItemError =
            document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError && message !== '') {
            lineItemError.classList.remove('hidden');
            lineItemError.querySelector('.js-cart-item-error-text') ? lineItemError.querySelector('.js-cart-item-error-text').innerHTML = message : null
        }

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus =
            document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        if (!cartStatus) return

        cartStatus.setAttribute('aria-hidden', false);
        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({note: event.target.value});
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
            }, ON_CHANGE_DEBOUNCE_TIMER))
        }
    });
}

class GiftWrappingElement extends HTMLElement {
    constructor() {
        super();
        this.cartUpdateUnsubscriber = null;
        this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        this.cartDrawerWrapper = document.querySelector('cart-drawer');
        this.cartFooter = document.getElementById('main-cart-footer');
        this.giftWrappingId = this.dataset.giftWrappingId;
    }

    updateCartItems() {
        let sectionId, container;
        let headerCart = document.getElementById('basketIcon')
        if (this.closest('cart-items')) {
            sectionId = 'main-cart-items';
            container = document.querySelector('#main-cart-items .js-contents');
        } else {
            sectionId = 'cart-drawer';
            container = document.querySelector('#CartDrawer-CartItems .js-contents');
        }

        const loader = document.querySelector('.js-cart-loader[data-loader]');
        window.Global.showLoader(loader);

        fetch(`${routes.cart_url}?sections=${sectionId},header`)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = JSON.parse(html)
                
                const cartSection = parser.parseFromString(doc[sectionId], 'text/html');
                const headerSection = parser.parseFromString(doc['header'], 'text/html');
                if (headerSection){
                    if (headerCart) {
                        headerCart.innerHTML = headerSection.querySelector('#basketIcon').innerHTML;
                    }

                    const mainCartPriceEl = document.querySelector(".js-main-cart-price")
                    if (mainCartPriceEl) {
                        mainCartPriceEl.innerHTML = headerSection.querySelector('#cart-price').innerHTML
                    }
                    
                    const drawerCartPriceEl = document.querySelector(".js-drawer-price")
                    if (drawerCartPriceEl) {
                        drawerCartPriceEl.innerHTML = headerSection.querySelector('#cart-price > div').innerHTML
                    }
                }

                let updatedContainer = cartSection.querySelector(
                    this.parentElement.id === "CartDrawer-Form"
                        ? '#CartDrawer-CartItems .js-contents'
                        : '#main-cart-items .js-contents'
                );
                if (!updatedContainer && this.closest('cart-drawer')) {
                    container = document.querySelector('#CartDrawer');
                    updatedContainer = cartSection.querySelector('#CartDrawer')
                }
                if (updatedContainer && container) {
                    container.innerHTML = updatedContainer.innerHTML;
                }
            })
            .catch(e => console.error(e))
            .finally(() => {
                window.Global.hideLoader(loader);
            });
    }

    removeGiftWrap() {
        const body = JSON.stringify({
            updates: {
                [this.giftWrappingId]: 0
            },
            attributes: {
                'gift_wrapping': false
            }
        });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}})
            .then(() => {
                this.updateCartItems();
            })
            .catch(e => console.error(e));
    }


    setGiftWrap() {
        if (this.closest('cart-drawer')) {
            if (this.desiredQty <= 0) {
                this.removeGiftWrap()
            }
        }
        const body = JSON.stringify({
            updates: {
                [this.giftWrappingId]: parseInt(this.desiredQty, 10)
            },
            attributes: {
                'gift_wrapping': this.desiredQty > 0,
            }
        });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}})
            .then(() => {
                this.updateCartItems();
            })
            .catch(e => console.error(e));
    }

    updateDesiredQty(cart) {
        let giftWrapsInCart = 0;
        if (cart.items) {
            cart.items.forEach((item) => {
                if (item.id === parseInt(this.giftWrappingId)) {
                    giftWrapsInCart += parseInt(item.quantity, 10);
                }
            });
        }
        const nonGiftCount = cart.item_count - giftWrapsInCart;

        if (nonGiftCount <= 0) {
            if (this.checkbox.checked) {
                this.checkbox.checked = false;
            }
            if (giftWrapsInCart > 0) {
                this.removeGiftWrap();
                this.cartItems.classList.toggle('is-empty', true);
                if (this.cartFooter) this.cartFooter.classList.toggle('is-empty', true);
                if (this.cartDrawerWrapper) this.cartDrawerWrapper.classList.toggle('is-empty', true);
            }
            return;
        }

        if (!this.individual) {
            return;
        }

        const newDesiredQty = nonGiftCount;
        if (newDesiredQty !== this.desiredQty) {
            this.desiredQty = newDesiredQty;
            if (this.checkbox.checked) {
                this.setGiftWrap();
            }
        }
    }

    connectedCallback() {
        this.checkbox = this.querySelector('#gift-wrapping-checkbox');
        if (!this.checkbox) {
            return;
        }

        this.giftWrappingId = this.dataset.giftWrappingId;
        this.desiredQty = parseInt(this.dataset.desiredQty, 10) || 0;
        this.individual = this.dataset.individual === 'true';

        this.checkbox.addEventListener('change', (event) => {
            if (event.target.checked) {
                this.setGiftWrap();
            } else {
                this.removeGiftWrap();
            }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'gift-wrapping') return;
            if (this.closest('cart-drawer')) {
                if (event.source === 'product-form') {
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => this.updateDesiredQty(cart))
                        .catch(e => console.error(e));
                } else {
                    this.desiredQty = parseInt(this.dataset.desiredQty, 10) || 0;
                    if (this.checkbox.checked) {
                        this.setGiftWrap();
                    }
                }
                return;
            }

            if (event.source === 'product-form') {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => this.updateDesiredQty(cart))
                    .catch(e => console.error(e));
            } else if (event.cartData && event.cartData.items) {
                this.updateDesiredQty(event.cartData);
            }
        });

    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

}

customElements.define('gift-wrapping', GiftWrappingElement);

if (!customElements.get('gift-note')) {
    customElements.define('gift-note', class GiftNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({attributes: {'gift_note': event.target.value}});
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
            }, ON_CHANGE_DEBOUNCE_TIMER))
        }
    });
}
